export const situationsFour = [
  {
    id: 1,
    text: "You are not able to take out time for self-study but you have to teach and guide your siblings also. You will...",
    response:
      "Cut some time from unessential work, made a proper schedule and did group study with siblings.",
  },
  {
    id: 2,
    text: "He wanted to go for adventure sports like rafting etc but his mother was worried about her only son. He...",
    response:
      "He told his interest and also about safety measures, convinced her and went to adventure sports. ",
  },
  {
    id: 3,
    text: "One day before the award function, he is informed that the award will be given to another student instead of him. He...",
    response:
      "He congratulated other awardee and worked for better performance.",
  },
  {
    id: 4,
    text: "You are asked to pay a double amount of fees in your institution without any clear cause. You will...",
    response:
      "Didn’t pay it and also stopped others from paying and registered a complaint against institution.",
  },
  {
    id: 5,
    text: "While going to the market you see two people abusing each other. You will...",
    response: "Ignored and moved ahead.",
  },
  {
    id: 6,
    text: "He was asked to report to his boss urgently, while he was going up in a lift the electric power supply failed. He...",
    response:
      " He pressed alarm, called security, informed the boss about the delay and went to boss after coming out of the lift.",
  },
  {
    id: 7,
    text: "His cousin wants to borrow some NCERT books, his poor friend is also in need of the same. He...",
    response:
      "He gave his books to the poor friend and arranged books for the cousin from other friends.",
  },
  {
    id: 8,
    text: "His marriage has been fixed but just one weak prior to the marriage the girl's father meets with an accident and loses his leg. He...",
    response:
      " He postponed marriage, took care of father in law and got married after recovery.",
  },
  {
    id: 9,
    text: "He was parking his new bike when a woman with whom his family had a fight started shouting at him and asked him not to park at that place. He...",
    response: "Took it lightly and parked his bike somewhere else.",
  },
  {
    id: 10,
    text: "Her class teacher used to comment on her classmates and especially girls. She...",
    response:
      "She complained to the principal and got new class teacher appointed and got him restricted.",
  },
  {
    id: 11,
    text: "You are attending the funeral of your close relative when suddenly your friend calls you to arrange oxygen cylinder for his mother. You...",
    response:
      "Contacted friends, went to nearby hospitals and medical shop, made arrangement and delivered oxygen cylinder.",
  },
  {
    id: 12,
    text: "You filed a complaint regarding cybercrime but no action been taken since one month. You...",
    response:
      "Wrote a letter to District Magistrate to inspect the complaint and got the decision in favor.",
  },
  {
    id: 13,
    text: "He is not permitted to take an examination due to want of certain requisite certificate which his college has refused to give him. He will...",
    response:
      "He showed the written undertaking from college to examiner and gave the exam.",
  },
  {
    id: 14,
    text: "He finds ten people quarreling over a purse fallen from the bus. The police have approached and they have run away and he is found with a purse by the police. The police take him to the police station. He ...",
    response:
      " He told the truth, insisted them to check CCTV and proved his innocence.",
  },
  {
    id: 15,
    text: "He is the leader of the hiking party but due to some reasons two persons of the party wants to return from the middle of the hike. He...",
    response:
      "He inquired the reason, if found urgent, helped in commutation and continued the hiking.",
  },
  {
    id: 16,
    text: "He is traveling in an emergency while his city is in lockdown. Some policemen restrict his movement as he is not carrying lockdown e-pass. He...",
    response:
      "He told the emergency reason, booked pass from the online portal and took permission for smooth movement.",
  },
  {
    id: 17,
    text: "In a party thrown by him on his promotion his boss gets annoyed due to the sarcastic remarks of his elder brother and he leaves the party without taking meals. He...",
    response:
      " He apologized on brother's behalf, told his bother’s remark didn’t mean to hurt, invited him for dinner and removed misunderstanding.",
  },
  {
    id: 18,
    text: "On her way to the office she is harassed by some goons on a lonely road. She...",
    response:
      "She kept moving, confronted them on the busy road, called police and got them arrested.",
  },
  {
    id: 19,
    text: "In the theater you notice some people making fun of a person who has visited a theater for the first time. You...",
    response:
      "Confronted them, made them apologize, and enjoyed the movie together.",
  },
  {
    id: 20,
    text: "You find partiality in the skating championship results. As the chief guest you will...",
    response:
      "Address the issue with the authority and recognized the best performer.",
  },
  {
    id: 21,
    text: "One evening he notices his friend moving with the girlfriend of another friend. He...",
    response:
      "Talked to him and hinted him not to take any step that can ruin the friendship.",
  },
  {
    id: 22,
    text: "He notices some students creating chaos in an online class. He will...",
    response:
      "Told them to maintain a boundary, muted them and focused on the teacher.",
  },
  {
    id: 23,
    text: "He receives information about some people raising funds in name of cancer patients and misusing the money. He...",
    response:
      "He informed police and health department, spread awareness among people and got the fraudster arrested.",
  },
  {
    id: 24,
    text: "His sister has passed her graduation, his father want her to get married and mother want her to study further. He...",
    response:
      " He explained sister's interest to father, convinced him to allow her to study, and helped her.",
  },
  {
    id: 25,
    text: "In the mid of his song performance, the guitarist went off tune. He will...",
    response: "Continued performing and signaled to change the guitar.",
  },
  {
    id: 26,
    text: "You want to create an NGO to help the covid orphans but you are short of volunteers. You will...",
    response:
      "Circulate information in groups and advertise in the newspaper, told people about the vision of NGO, won the confidence of people and got volunteers.",
  },
  {
    id: 27,
    text: "On the first day of college you spoil your image in front of your professor. You will...",
    response:
      "Remained honest and disciplined and gradually established a good relationship with the professor.",
  },
  {
    id: 28,
    text: "He was entering his lane when he found some smoke coming out from a house and a child was playing inside and even the windows were closed. He...",
    response:
      "He told the watchman to cut the power supply, went inside the house, opened windows and gate, took the child out and informed family members",
  },
  {
    id: 29,
    text: "Your aunt has extramarital affairs with someone. You will...",
    response: "Inform my uncle about it.",
  },
  {
    id: 30,
    text: "You as the policeman comes to know that your brother is a smuggler. You...",
    response: "Convinced him to surrender and help police in the crackdown.",
  },
  {
    id: 31,
    text: "You are representing national cricket team and during a match some unknown people came and offered you money for under-performing. You...",
    response:
      "Rejected the proposal and complaint to cricket board and gave his best performance.",
  },
  {
    id: 32,
    text: "There was a passenger in the bus whose hand was fractured and had difficulty carrying the luggage. You...",
    response: "Helped him with his luggage and also helped him get a seat.",
  },
  {
    id: 33,
    text: "Indian Armed Forces is his dream. To achieve this he...",
    response:
      "He analyzed the requirements, improved his personality and physical, worked hard in his preparation and fulfilled his dream.",
  },
  {
    id: 34,
    text: "You have to craft a wall hanging for the kids but you have no knowledge about art and craft. You...",
    response: "Took help from Youtube and crafted the wall hanging..",
  },
  {
    id: 35,
    text: "The weather is beautiful and he wants to hang out but the college timing are creating a hurdle in his plan. He...",
    response:
      "He convinced friends to hang out after college hours and enjoyed the weather.",
  },
  {
    id: 36,
    text: "Whenever he has to work under pressure, he...",
    response: "He remains calm and gives his best.",
  },
  {
    id: 37,
    text: "His marriage was scheduled for February but he got a great offer to go abroad one day before his marriage. He...",
    response:
      "He preponed the marriage, made all arrangements and went abroad with his wife.",
  },
  {
    id: 38,
    text: "He noticed his sister getting addicted to mobile phone. He will...",
    response:
      "He installed a habit tracker with a time limit on her mobile and suggested her to minimize its’s usage.",
  },
  {
    id: 39,
    text: "You are a south Indian and you have to travel to a rural town in Haryana for a job survey & you have no one to accompany you on the trip. You...",
    response:
      "Found a local who knows both English and local language and used him as a translator and completed the survey.",
  },
  {
    id: 40,
    text: "You are in charge to release salary for your unit as they are going to home for Diwali leave. You notice some cash missing from its place. You...",
    response:
      "Checked CCTV, set up a departmental inquiry, caught the culprit and recovered the money.",
  },
  {
    id: 41,
    text: "While returning home after watching a movie at midnight, he found a man carrying a woman on his back on a lonely way. He...",
    response: "He inquired about the situation and helped them accordingly. ",
  },
  {
    id: 42,
    text: "You notice partiality in rank promotion in your NCC squadron. You...",
    response:
      "Informed NCC battalion in-charge and convinced him to check selection process.",
  },
  {
    id: 43,
    text: "You find your best friend changed and being friendly with person you dislike. You...",
    response: "Took it lightly and didn't change my behavior towards him.",
  },
  {
    id: 44,
    text: "He had a serious fight with his sister and sees his sister seeking help from his rival. He...",
    response:
      "He went to her and helped her in every possible manner and resolved fight.",
  },
  {
    id: 45,
    text: "He had an essay competition tomorrow, outside there was a lot of noise due to cricket match. He...",
    response: "He went to a library and prepared for competition.",
  },
  {
    id: 46,
    text: "He saw a handicapped person trying to cross the traffic. He...",
    response: "Gave signal to vehicles to stop and helped him cross safely.",
  },
  {
    id: 47,
    text: "When he observed that his friend was having some suspicion on him...",
    response: "He talked to him and cleared all doubts and removed suspicion.",
  },
  {
    id: 48,
    text: "You come to know that your sister is in love with your enemy and wants to marry him. You...",
    response:
      "Asked sister about the seriousness of the relationship and if found genuine, helped them in settlement and resolved all conflict with the enemy.",
  },
  {
    id: 49,
    text: "His father saw him smoking. He...",
    response: " He apologized and promise not to smoke again.",
  },
  {
    id: 50,
    text: "You saw your younger brother teasing a girl. You...",
    response:
      "Scolded him, made him apologize, and ensured that he never does it again.",
  },
  {
    id: 51,
    text: "Your college is conducting online classes but your friend has no source to join it. You...",
    response: "Invited him to my house and both attended classes together. ",
  },
  {
    id: 52,
    text: "What is one important lesson you will pass to your younger brother/sister...",
    response: "To be honest and keep self-trust and hope in life. ",
  },
  {
    id: 53,
    text: "Your father got you admission in B.tech, but after a year you want to drop out and pursue Arts. You will...",
    response:
      "Told father about my interest and prospect and convinced him for Arts and pursued the same.",
  },
  {
    id: 54,
    text: "What major changes you would like to make in the education system of this country...",
    response:
      "Regular physical classes, introduction to sex Ed and mental health classes, creative learning and freedom to choose and study any subject.",
  },
  {
    id: 55,
    text: "Your mother wants to start a small In-house business, but your father is against it. You will...",
    response:
      "Talked to father, told him about business growth & stability and mother's happiness, convinced him and helped mother in doing the same.",
  },
  {
    id: 56,
    text: "He is pursuing his B.tech and in an urgent need of a laptop, but he can't afford to buy a laptop. He...",
    response:
      "Took a part-time job, saved some money and bought it on EMI, meanwhile used friend’s laptop.",
  },
  {
    id: 57,
    text: "He took friend's camera for a trip but the lens of the camera got damaged on the trip. He will...",
    response: "He apologized to the friend, repair the lens and returned it.",
  },
  {
    id: 58,
    text: "You are an officer in Indian army and two jawans of your battalion had a severe fight and one of them is hospitalized. You will...",
    response:
      "Hold inquiry and took departmental action, went to MH to know injured jawan condition and follow up the matter.",
  },
  {
    id: 59,
    text: "Where do you see yourself in the next five years...",
    response: "As a person leading the men in front and motivating youth.",
  },
  {
    id: 60,
    text: "You find yourself getting addicted to social media. What will you do to overcome it...",
    response:
      "Installed blocker on the mobile with a timer to minimize social media usage.",
  },
  {
    id: 60,
    text: "You find yourself getting addicted to social media. What will you do to overcome it...",
    response:
      "Installed blocker on the mobile with a timer to minimize social media usage.",
  },
];
